<template>
  <v-card class="pa-4">
    <div class="d-flex justify-space-between align-center">
      <div class="text-h6">Hiring Manager's Status and  Remark</div>
      <v-chip
        v-if="remarks?.status"
        :class="getStatusClass(remarks.status)"
        class="rounded-pill"
      >
        {{ formatStatus(remarks.status,round) }}
      </v-chip>
    </div>
    
    
    <div class="mt-4">Hiring Manager - {{ remarks.hiringManagerDetails.hiringManagerName }} ({{ remarks.hiringManagerDetails.hiringManagerEmail }})</div>
    
    <div v-if="remarks">
      <div class="mt-4" v-html="remarks.remark"></div>
    </div>
    <div v-else class="text-center py-4">
      No remark available
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'RemarkCard',
  props: {
    remarks: {
      type: Object,
      default: null
    },
    round: {
      type: Number,
      required: true
    }
  },
  methods: {
    formatStatus(status,round) {
      const statusMap = {
        'ACCEPT': 'Accepted',
        'REJECT': `Rejected at R${round}`,
        'ONHOLD': 'On Hold',
        'NOTIFY_HR': 'Notified HR',
        'ROUND_ACCEPTED': `Accepted at R${round}`,
        'SEND_TO_HIRING_MANAGER': 'Sent to Hiring Manager'
      };
      return statusMap[status];
    },
    getStatusClass(status) {
      const classMap = {
        'ACCEPT': 'accepted-status',
        'REJECT': 'rejected-status',
        'ONHOLD': 'on-hold-status',
        'NOTIFY_HR': 'notify-hr-status',
        'ROUND_ACCEPTED': 'notify-hr-status',
        'SEND_TO_HIRING_MANAGER': 'hiring-manager-status'
      };
      return classMap[status] || 'default-chip';
    }
  }
}
</script>

<style scoped>
.rounded-pill {
  border-radius: 24px;
}
.accepted-status {
  background: var(--success-03) !important;
  color: var(--success-02);
}
.rejected-status {
  background: var(--error-03) !important;
  color: var(--red);
}
.hiring-manager-status {
  background: #E8E3FF !important;
  color: #6D54E1;
}
.on-hold-status {
  background: var(--light-yellow) !important;
  color: var(--orange);
}
.notify-hr-status {
  background: #EFDCF8  !important;
  color: #AF52DE;
}
.default-chip {
  color: blue;
  background: #3F41D12B !important;
}
</style>
